import { render } from "./IPProgressBar.vue?vue&type=template&id=a6305e68"
import script from "./IPProgressBar.vue?vue&type=script&lang=js"
export * from "./IPProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__